<template>
    <span class="calc-tip-wrap" tabindex="0">
        <span class="calc-tip-icon">
            <CalcIcon name="info" />
        </span>
        <span class="calc-tooltip" role="tooltip">
            <slot />
        </span>
    </span>
</template>

<script>
import CalcIcon from './CalcIcon.vue'

export default {
    name: 'CalcTooltip',

    components: { CalcIcon },
}
</script>

<style scoped>
.calc-tip-wrap {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.calc-tip-icon {
    width: 18px;
    height: 18px;
    display: grid;
    place-items: center;
    cursor: pointer;
    color: inherit;
    transition: opacity var(--calc-t-fast);
}

.calc-tip-icon:hover {
    opacity: 0.8;
}

.calc-tooltip {
    position: absolute;
    left: 26px;
    top: -8px;
    width: 360px;
    background: white;
    border: 1px solid var(--calc-line);
    border-radius: 12px;
    padding: 18px 20px;
    font-size: 14px;
    line-height: 1.5;
    color: var(--calc-ink);
    box-shadow: 0 12px 32px rgba(4, 15, 15, 0.12);
    z-index: 30;
    opacity: 0;
    pointer-events: none;
    transform: translateY(-4px);
    transition:
        opacity var(--calc-t-med),
        transform var(--calc-t-med);
}

.calc-tip-wrap:hover .calc-tooltip,
.calc-tip-wrap:focus-within .calc-tooltip {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
}

.calc-tooltip::before {
    content: '';
    position: absolute;
    left: -7px;
    top: 22px;
    width: 14px;
    height: 14px;
    background: white;
    border-left: 1px solid var(--calc-line);
    border-bottom: 1px solid var(--calc-line);
    transform: rotate(45deg);
}

@media (max-width: 760px) {
    .calc-tooltip {
        width: 280px;
        left: -120px;
        top: 28px;
    }
    .calc-tooltip::before {
        left: 130px;
        top: -7px;
        transform: rotate(135deg);
    }
}
</style>
